import { useHistory, useLocation } from "react-router";
import { InformacoesPessoais } from "../components/InformacoesPessoais";

export function DadosPessoais() {
    const history = useHistory();
    const location = useLocation<{ destination: string }>();

    const handleSubmit = () => {
        if (localStorage.getItem("destination")) {
            if (localStorage.getItem("destination") !== "/") history.push(localStorage.getItem("destination") || "/hoje");
            else history.push("/hoje");
        } else {
            history.push("/hoje");
        }
        // if (location.state && location.state.destination) {
        //     history.push(location.state.destination);
        // } else {
        //     history.push("/checkin-aula");
        // }
    };

    return (
        <div className="content-wrapper">
            <div className="content-heading">
                <div>Criar conta</div>
            </div>

            <InformacoesPessoais afterSubmit={handleSubmit} />
        </div>
    );
}
